// @flow

/* Suppressing by commenting out lines of code (see below)
import { GroupRow, CellType } from 'wijmo/wijmo.grid';
import Decimal from 'decimal.js';
*/

import { createColumnOrRowFormatter } from '../utils';
import type { FormatterArgs } from '../types';

const groupFormatter = (args?: FormatterArgs) =>
  createColumnOrRowFormatter({
    formatStyle: 'row', // can be wheter 'row' or 'cell'.
    /* Suppressing by commenting out lines of code
        Line 21:  'label' is assigned a value but never used       no-unused-vars
        Line 25:  'count' is assigned a value but never used       no-unused-vars
        Line 27:  'cases' is assigned a value but never used       no-unused-vars
        Line 35:  'total' is assigned a value but never used       no-unused-vars
        Line 48:  'baseButton' is assigned a value but never used  no-unused-vars
    */
    formatter: ({ elem, dataItem }) => {
      /*if (
        elem.panel.rows[elem.row] instanceof GroupRow &&
        elem.panel.cellType !== CellType.RowHeader
      ) {
        const flex = elem.panel.grid;

        // Get the header's name
        // Note: `flex.rows[elem.row].dataItem.name` should have the name but it's always `undefined`
        const label = elem.cell.textContent.replace(/\s*\(\d*\s*items\)/, '');
        // const value = flex.rows[elem.row].dataItem.name;

        // Get items in group
        const count = flex.rows[elem.row].dataItem.items.length;

        const cases = new Decimal(
          flex.rows[elem.row].dataItem.items.reduce((reducer, item) => {
            return reducer + item.Qty;
          }, 0),
        )
          .toDecimalPlaces(5, 1)
          .toNumber();

        const total = new Decimal(
          flex.rows[elem.row].dataItem.items.reduce((reducer, item) => {
            return reducer + item.Tot;
          }, 0),
        )
          .toDecimalPlaces(5, 1)
          .toNumber();

        const isCollapsed = flex.rows[elem.row].isCollapsed;

        // The following HTML was taken from what FlexGrid was
        // rendering before and extended to include the new set of
        // data
        const baseButton = `
          <button class="wj-btn wj-btn-glyph wj-elem-collapse" type="button" tabindex="-1" aria-label="Toggle Group" aria-expanded="${
            isCollapsed ? false : true
          }">
            <span class="${
              isCollapsed ? 'wj-glyph-right' : 'wj-glyph-down-right'
            }"></span>
          </button>
        `;

       /!* elem.cell.innerHTML = `
          ${baseButton} ${label} (${count} items) - <strong>Cases:</strong> ${cases} / <strong>Total:</strong> ${total}
        `; *!/
      }*/
    },
  });

export default groupFormatter;
